import {
  pushEddlFaqEvent,
  parseFaqCategories,
} from 'ewi-ui-helpers/services/dataLayerFaq';

(() => {
  window.addEventListener('load', () => {
    const accordionItems = document.querySelectorAll('.accordionItem');

    const handleAccordionItemClick = (accordionItem) => {
      const isOpen = accordionItem.classList.contains('accordionItem--open');
      const accordionContent = accordionItem.querySelector(
        '.accordionItem__content_inner',
      );
      const accordionButton = accordionItem.querySelector('button');

      if (isOpen) {
        accordionItem.classList.remove('accordionItem--open');
        accordionContent.setAttribute('inert', 'true');
        accordionButton.setAttribute('aria-expanded', 'false');
      } else {
        accordionItem.classList.add('accordionItem--open');
        accordionContent.removeAttribute('inert');
        accordionButton.setAttribute('aria-expanded', 'true');

        const { faqId, categories } = accordionItem.dataset;
        if (faqId) {
          pushEddlFaqEvent('faq_expand', faqId, parseFaqCategories(categories));
        }
      }
    };

    const setAccesibilityDefaults = (accordionItem) => {
      const isOpen = accordionItem.classList.contains('accordionItem--open');
      const accordionContent = accordionItem.querySelector(
        '.accordionItem__content_inner',
      );
      const accordionButton = accordionItem.querySelector('button');

      if (isOpen) {
        accordionContent.removeAttribute('inert');
        accordionButton.setAttribute('aria-expanded', 'true');
      } else {
        accordionContent.setAttribute('inert', 'true');
        accordionButton.setAttribute('aria-expanded', 'false');
      }
    };

    accordionItems.forEach((accordionItem) => {
      setAccesibilityDefaults(accordionItem);

      const accordionButton = accordionItem.querySelector('button');
      accordionButton.addEventListener('click', () =>
        handleAccordionItemClick(accordionItem),
      );
    });

    const showAllAccordionItemsButtons = document.querySelectorAll(
      '.js_show_all_accordion_items',
    );
    if (showAllAccordionItemsButtons) {
      showAllAccordionItemsButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetAccordionSelector = button.getAttribute('aria-controls');
          button.classList.add('d-none');
          button.classList.remove('d-inline-flex');
          button.setAttribute('aria-expanded', 'true');
          if (targetAccordionSelector) {
            document
              .querySelector('#' + targetAccordionSelector)
              ?.classList.remove('show-first-5');
          }
        });
      });
    }
  });
})();
